import { scheduleResource } from '@/api'

const state = {
  loading: false,
  schedules: []
}

const getters = {
  schedules: (state) => {
    return state.schedules
  }
}

const actions = {
  loadScreens ({ commit }) {
    commit('SET_LOADING', true)

    scheduleResource.all().then(res => {
      commit('SET_SCHEDULES', res.data.returnValue)
      commit('SET_LOADING', false)
    }).catch(err => {
      console.log(err)
    })
  },

  addScreen ({ commit }, schedule) {
    scheduleResource.create(schedule).then((res) => {
      commit('ADD_SCHEDULE', res.data.returnValue)
    })
  },

  removeScreen ({ commit }, schedule) {
    scheduleResource.destroy(schedule.scheduleId).then(() => {
      commit('REMOVE_SCHEDULE', schedule)
    })
  },

  clearScreens ({ commit }) {
    commit('SET_SCHEDULES', [])
  }
}

const mutations = {
  SET_LOADING (state, isLoading) {
    state.loading = isLoading
  },

  SET_SCHEDULES (state, schedules) {
    state.schedules = schedules
  },

  ADD_SCHEDULE (state, schedule) {
    state.schedules.push(schedule)
  },

  REMOVE_SCHEDULE (state, schedule) {
    let i = state.schedules.map(item => item.scheduleId).indexOf(schedule.scheduleId)
    state.schedules.splice(i, 1)
  }
}

export default { namespaced: true, state, getters, actions, mutations }
